import type { PurposeFilter } from "@/api/types";

export const PURPOSE_FILTERS: readonly PurposeFilter[] = [
  "slippage_capture",
  "unclassified_swap_payout",
  "performance_fee",
  "lp_withdrawal_remainder",
  "none",
];

export const PURPOSE_LABELS: Record<PurposeFilter, string> = {
  slippage_capture: "Slippage capture",
  unclassified_swap_payout: "Unclassified swap payout",
  performance_fee: "Performance fee",
  lp_withdrawal_remainder: "LP withdrawal remainder",
  none: "No purpose label",
};
